import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { apiFetch, parseJsonSafe } from '../utils/api';
import './customer/CustomerPortal.css';

const CustomerResetPage = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const [requesting, setRequesting] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const [done, setDone] = useState(false);

  // Si llega ?token= en la URL (enlace del email), salta al paso 2 con el código precargado
  useEffect(() => {
    const t = new URLSearchParams(window.location.search).get('token');
    if (t) { setToken(t); setStep(2); }
  }, []);

  const requestReset = async (e) => {
    e.preventDefault();
    if (requesting) return;
    setError('');
    setMsg('');
    setRequesting(true);
    try {
      const res = await apiFetch('/api/v1/software/customer/password/reset', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email })
      });
      const data = await parseJsonSafe(res);
      if (!res.ok) return setError(data?.message || 'No se pudo completar la operacion, intentalo de nuevo');
      setMsg(data?.message || 'Solicitud recibida. Revisa tu email.');
      setStep(2);
    } catch (_e) {
      setError('No se pudo completar la operacion, intentalo de nuevo');
    } finally {
      setRequesting(false);
    }
  };

  const confirmReset = async (e) => {
    e.preventDefault();
    if (confirming || done) return;
    setError('');
    setMsg('');
    setConfirming(true);
    try {
      const res = await apiFetch('/api/v1/software/customer/password/reset/confirm', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ reset_token: token, password })
      });
      const data = await parseJsonSafe(res);
      if (!res.ok) return setError(data?.message || 'No se pudo completar la operacion, intentalo de nuevo');
      setMsg(data?.message || 'Contrasena actualizada correctamente. Redirigiendo...');
      setDone(true);
      setTimeout(() => navigate('/cliente/login'), 2000);
    } catch (_e) {
      setError('No se pudo completar la operacion, intentalo de nuevo');
    } finally {
      setConfirming(false);
    }
  };

  return (
    <div className="customer-portal">
      <div className="cp-auth-wrapper">
        <div className="cp-auth-brand">
          <div className="cp-auth-brand-title">Recuperar contrasena</div>
          <div className="cp-auth-brand-subtitle">
            Te enviaremos un token de recuperacion a tu email para restablecer tu contrasena.
          </div>
        </div>
        <div className="cp-auth-form-side">
          <div className="cp-auth-form">
            <h1>Restablecer contrasena</h1>
            <p>Sigue los pasos para recuperar tu acceso</p>

            <div className="cp-steps">
              <div className={`cp-step ${step === 1 ? 'active' : step > 1 ? 'done' : ''}`}>
                <div className="cp-step-circle">{step > 1 ? '\u2713' : '1'}</div>
                <span>Solicitar</span>
              </div>
              <div className={`cp-step-line${step > 1 ? ' done' : ''}`} />
              <div className={`cp-step ${step === 2 ? 'active' : ''}`}>
                <div className="cp-step-circle">2</div>
                <span>Confirmar</span>
              </div>
            </div>

            {error && <div className="cp-alert cp-alert-error" role="alert">{error}</div>}
            {msg && <div className="cp-alert cp-alert-success" role="alert">{msg}</div>}

            {step === 1 && (
              <form onSubmit={requestReset}>
                <label className="cp-label" htmlFor="cp-reset-email">Email de tu cuenta</label>
                <input id="cp-reset-email" className="cp-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@email.com" required disabled={requesting} />
                <button type="submit" className="cp-btn cp-btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: 8 }} disabled={requesting}>
                  {requesting ? 'Enviando...' : 'Solicitar token'}
                </button>
              </form>
            )}

            {step === 2 && (
              <form onSubmit={confirmReset}>
                <label className="cp-label" htmlFor="cp-reset-token">Token de recuperacion</label>
                <input id="cp-reset-token" className="cp-input" value={token} onChange={(e) => setToken(e.target.value)} placeholder="Pega el token recibido" required disabled={confirming || done} />
                <label className="cp-label" htmlFor="cp-reset-password">Nueva contrasena</label>
                <input id="cp-reset-password" className="cp-input" type="password" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Min. 8 caracteres" minLength={8} required disabled={confirming || done} />
                <button type="submit" className="cp-btn cp-btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: 8 }} disabled={confirming || done}>
                  {done ? 'Redirigiendo...' : confirming ? 'Actualizando...' : 'Actualizar contrasena'}
                </button>
                <button type="button" className="cp-btn cp-btn-ghost" style={{ width: '100%', justifyContent: 'center', marginTop: 4 }} onClick={() => setStep(1)} disabled={confirming || done}>
                  Volver al paso 1
                </button>
              </form>
            )}

            <div className="cp-auth-links">
              <Link to="/cliente/login">Volver a login</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerResetPage;
